import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function getCompanies(category: number) {
  return API.get(Constants.APIURLS.COMPANIESBYCAT + category);
}

export function getOffers(codCompany: number) {
  return API.get(Constants.APIURLS.OFFERS + codCompany);
}
